import { render, staticRenderFns } from "./HistorialTransferencias.vue?vue&type=template&id=5ec33fd4&scoped=true&"
import script from "./HistorialTransferencias.vue?vue&type=script&lang=js&"
export * from "./HistorialTransferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec33fd4",
  null
  
)

export default component.exports